import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { resources } from "badlands-shared/locales";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "en-US",
    lng: "en-US",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    showSupportNotice: false,
  });

export default i18n;
